/* eslint-disable react/jsx-no-bind */
import { LinkTypeEnum } from '@hqo/hqo-miniapp-client-sdk';
import { MiniappSdkDemoInput } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-demo-input';
import { MiniappSdkRootMethodDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-root-method-demo';
import { useMemo, useState } from 'react';

export const MiniappSdkRedirectToContentDemo = (): JSX.Element => {
  const [value, setValue] = useState('');
  const [type, setType] = useState(LinkTypeEnum.NATIVE_LINK);
  const args = useMemo(() => [{ value, type }], [value, type]);

  return (
    <MiniappSdkRootMethodDemo action="redirectToContent" eventName="redirectToContentResponse" args={args}>
      <MiniappSdkDemoInput
        value={value}
        onChange={setValue}
        placeholder="Navigation value"
        dataTestId="redirectToContentValue"
      />
      <MiniappSdkDemoInput
        value={type}
        onChange={(nextType) => setType(nextType as LinkTypeEnum)}
        placeholder="Link type (e.g. NATIVE_LINK)"
        dataTestId="redirectToContentType"
      />
    </MiniappSdkRootMethodDemo>
  );
};
